import * as Sentry from '@sentry/browser';
import { googleLogout } from '@react-oauth/google';
import { removeUserAccess } from './sessionTokens';

export const useSignout = (setAuthStatus) => {
  const handleLogout = () => {
    setAuthStatus(new Date());
    removeUserAccess();
    window.location.reload();
  };

  const handleLogoutFailure = (error) => {
    Sentry.captureException(error);
    window.location.reload();
  };

  const signOut = () => {
    try {
      googleLogout();
      handleLogout();
    } catch (error) {
      handleLogoutFailure(error);
    }
  };

  return { signOut };
};
